module.exports = __webpack_public_path__ + "media/images/lb/056-5218d1a3ffc273c215a40b1ad48bbc0d.svg";